import React from 'react';
import { Card } from './ui/card';
import { FileText, CheckCircle, Send, Info, Scale, Briefcase } from 'lucide-react';
import ResponsiveCardSlider from './ResponsiveCardSlider';

const ProcessCards = ({ activeTab }) => {
  const selfFilingCards = [
    {
      title: 'Application Preparation',
      icon: FileText,
      description: 'Trademark Resolutions reviews your filing information, identifies the correct trademark class, and prepares your application for submission through the USPTO TEAS system.'
    },
    {
      title: 'Identity Review and Approval',
      icon: CheckCircle,
      description: 'You complete ID.me verification, then check the attorney-prepared application in detail. Any required edits or changes can be requested before submission.'
    },
    {
      title: 'USPTO Filing',
      icon: Send,
      description: 'After approval, Trademark Resolutions submits your application to the USPTO, ensuring every detail is accurate, complete, and ready for official review.'
    }
  ];

  const attorneyLedCards = [
    {
      title: 'Information Collection',
      icon: Info,
      description: 'We collect your trademark details, including name, logo (if applicable), and a brief description of your products/services.'
    },
    {
      title: 'Attorney Review & Application Drafting',
      icon: Scale,
      description: 'Our IP attorney reviews your case, determines the appropriate trademark class(es), and prepares a strong, USPTO-compliant application.'
    },
    {
      title: 'Filing & Case Management',
      icon: Briefcase,
      description: 'We file the application on your behalf and handle all procedural steps, including monitoring your application and managing any USPTO correspondence.'
    }
  ];

  const cards = activeTab === 1 ? selfFilingCards : attorneyLedCards;

  return (
    <ResponsiveCardSlider className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
      {cards.map((card, index) => {
        const Icon = card.icon;
        return (
          <Card key={index} className="p-6 border-2 border-gray-200 hover:border-teal-400 transition-all duration-300 hover:shadow-lg">
            <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
              <Icon className="h-7 w-7 text-teal-600" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">{card.title}</h3>
            <p className="text-gray-600 text-sm">{card.description}</p>
          </Card>
        );
      })}
    </ResponsiveCardSlider>
  );
};

export default ProcessCards;
